export const DOCUMENT_ADD_OR_UPDATE = 'DOCUMENT_ADD_OR_UPDATE'
export const DOCUMENT_CREATE = 'DOCUMENT_CREATE'
export const DOCUMENT_CREATE_INQUIRY_RELATIONSHIP = 'DOCUMENT_CREATE_INQUIRY_RELATIONSHIP'
export const DOCUMENT_DOWNLOAD = 'DOCUMENT_DOWNLOAD'
export const DOCUMENT_DOWNLOAD_ALL = 'DOCUMENT_DOWNLOAD_ALL'
export const DOCUMENT_UPDATE_ID = 'DOCUMENT_UPDATE_ID'
export const DOCUMENT_UPDATE_PROGRESS = 'DOCUMENT_UPDATE_PROGRESS'
export const DOCUMENT_UPDATE_STATUS = 'DOCUMENT_UPDATE_STATUS'
